import {
  PrimitiveArraySerializer6xcmeltdozbx as PrimitiveArraySerializer,
  PrimitiveArrayBuilder1tzna3i4eqw54 as PrimitiveArrayBuilder,
} from './CollectionSerializers.mjs';
import { Companion_getInstance25gmlt2koipdc as Companion_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  serializer345btyh1f2y1j as serializer,
  serializer1wpgysz06u9ol as serializer_0,
  serializer3x9uckd1deom as serializer_1,
  serializerodflzzf6s3fp as serializer_2,
  serializer2lw83vwvpnyms as serializer_3,
  serializer1hu9wv9at41ww as serializer_4,
  serializer3ikrxnm8b29d6 as serializer_5,
  serializer1tw0a8bv7lkga as serializer_6,
  serializer1q7c5q67ysppr as serializer_7,
  serializer1r0h5yakm679b as serializer_8,
  serializer36584sjyg5661 as serializer_9,
  serializer3u3hsxnenk49x as serializer_10,
} from '../builtins/BuiltinSerializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isCharArray21auq5hbrg68m as isCharArray,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  isFloatArrayjjscnqphw92j as isFloatArray,
  isIntArrayeijsubfngq38 as isIntArray,
  isShortArraywz30zxwtqi8h as isShortArray,
  isByteArray4nnzfn1x4o3w as isByteArray,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  charArray2ujmm1qusno00 as charArray,
  booleanArray2jdug9b51huk7 as booleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DoubleCompanionObject_instance1ylw2yrid1slz as DoubleCompanionObject_instance,
  FloatCompanionObject_instance3t6i70y0gcqkd as FloatCompanionObject_instance,
  IntCompanionObject_instance28fy14dkbnsoq as IntCompanionObject_instance,
  ShortCompanionObject_instance1fu9o4qt4acxj as ShortCompanionObject_instance,
  ByteCompanionObject_instance18rz6lk1n40xe as ByteCompanionObject_instance,
  BooleanCompanionObject_instancet14765pm6xtp as BooleanCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { Companion_instance1emejao0j81tg as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import { isLongArray21mxwb8b0y2ii as isLongArray } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  Companion_getInstance3sq3iu5mj6qnr as Companion_getInstance_0,
  _ULong___init__impl__c78o9k2ace6d5rqjy3k as _ULong___init__impl__c78o9k,
  _ULong___get_data__impl__fggpzb3nuonax14svlz as _ULong___get_data__impl__fggpzb,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  _ULongArray___get_size__impl__ju6dtr2nah336epvy32 as _ULongArray___get_size__impl__ju6dtr,
  ULongArray3nd0d80mdwjj8 as ULongArray,
  _ULongArray___init__impl__twm1l33skamtyptd0bw as _ULongArray___init__impl__twm1l3,
  ULongArray__get_impl_pr71q91hrljiwf3ydw7 as ULongArray__get_impl_pr71q9,
  _ULongArray___get_storage__impl__28e64j18lfm63gboypn as _ULongArray___get_storage__impl__28e64j,
  _ULongArray___init__impl__twm1l3177xx31ho2ogr as _ULongArray___init__impl__twm1l3_0,
  ULongArray__set_impl_z19mvh363pb115v7opl as ULongArray__set_impl_z19mvh,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULongArray.mjs';
import {
  Companion_getInstance18m03xf6clkk8 as Companion_getInstance_1,
  _UInt___init__impl__l7qpdl3eewek7byy9h9 as _UInt___init__impl__l7qpdl,
  _UInt___get_data__impl__f0vqqw3lsr2hwtcnhrf as _UInt___get_data__impl__f0vqqw,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _UIntArray___get_size__impl__r6l8ci3k5nk98x82cco as _UIntArray___get_size__impl__r6l8ci,
  UIntArrayrp6cv44n5v4y as UIntArray,
  _UIntArray___init__impl__ghjpc6ak19clsbdjq4 as _UIntArray___init__impl__ghjpc6,
  UIntArray__get_impl_gp5kza1kxwd5xaaogcr as UIntArray__get_impl_gp5kza,
  _UIntArray___get_storage__impl__92a0v01viy2k5yo7r3b as _UIntArray___get_storage__impl__92a0v0,
  _UIntArray___init__impl__ghjpc62getm75da1llz as _UIntArray___init__impl__ghjpc6_0,
  UIntArray__set_impl_7f2zu2cw69np79tatu as UIntArray__set_impl_7f2zu2,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UIntArray.mjs';
import {
  Companion_getInstance29d4047m08ot as Companion_getInstance_2,
  _UShort___init__impl__jigrne3qim87o3qpsbl as _UShort___init__impl__jigrne,
  _UShort___get_data__impl__g02451ec7jdumy4xob as _UShort___get_data__impl__g0245,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import {
  _UShortArray___get_size__impl__jqto1b2fpyop64vsgq4 as _UShortArray___get_size__impl__jqto1b,
  UShortArray11avpmknxdgvv as UShortArray,
  _UShortArray___init__impl__9b26efn7hvduli2mro as _UShortArray___init__impl__9b26ef,
  UShortArray__get_impl_fnbhmx3rlltx9hj2m37 as UShortArray__get_impl_fnbhmx,
  _UShortArray___get_storage__impl__t2jpv51n1tyfv5sshfj as _UShortArray___get_storage__impl__t2jpv5,
  _UShortArray___init__impl__9b26ef47nxakt8f86w as _UShortArray___init__impl__9b26ef_0,
  UShortArray__set_impl_6d8whp3peif80kgg2bn as UShortArray__set_impl_6d8whp,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShortArray.mjs';
import {
  Companion_getInstance3jsnccejczksw as Companion_getInstance_3,
  _UByte___init__impl__g9hnc418b8pq346rvu4 as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qrfg5oujomrowy as _UByte___get_data__impl__jof9qr,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UByteArray___get_size__impl__h6pkdv1042t8i4b34m4 as _UByteArray___get_size__impl__h6pkdv,
  UByteArray2qu4d6gwssdf9 as UByteArray,
  _UByteArray___init__impl__ip4y9n2qcungomhrpkq as _UByteArray___init__impl__ip4y9n,
  UByteArray__get_impl_t5f3hv2kcwqrq6tlagh as UByteArray__get_impl_t5f3hv,
  _UByteArray___get_storage__impl__d4kctti622i5rzxx5l as _UByteArray___get_storage__impl__d4kctt,
  _UByteArray___init__impl__ip4y9n1pi3c8nr86gsm as _UByteArray___init__impl__ip4y9n_0,
  UByteArray__set_impl_jvcicn1i6oj9yq6rlr5 as UByteArray__set_impl_jvcicn,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByteArray.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  copyOf2p23ljc5f5ea3 as copyOf,
  copyOfgossjg6lh6js as copyOf_0,
  copyOfq9pcgcgbldck as copyOf_1,
  copyOf9mbsebmgnw4t as copyOf_2,
  copyOf3rutauicler23 as copyOf_3,
  copyOf39s58md6y6rn6 as copyOf_4,
  copyOfwy6h3t5vzqpl as copyOf_5,
  copyOf37mht4mx7mjgh as copyOf_6,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CharArraySerializerClass;
function CharArraySerializer() {
  if (CharArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        CharArraySerializer_instance = null;
        super(serializer(Companion_getInstance()));
        CharArraySerializer_instance = this;
      }
      n20(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.n20((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      o20(_this__u8e3s4) {
        return new (CharArrayBuilder())(_this__u8e3s4);
      }
      x1u(_this__u8e3s4) {
        return this.o20((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n1x() {
        return charArray(0);
      }
      p20(decoder, index, builder, checkIndex) {
        builder.s20(decoder.x1r(this.e1x_1, index));
      }
      i1v(decoder, index, builder, checkIndex) {
        return this.p20(decoder, index, builder instanceof CharArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o1x(decoder, index, builder, checkIndex) {
        return this.p20(decoder, index, builder instanceof CharArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      t20(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.d1t(this.e1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      p1x(encoder, content, size) {
        return this.t20(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'CharArraySerializer', VOID, VOID, [KSerializer(), PrimitiveArraySerializer()]);
    CharArraySerializerClass = $;
  }
  return CharArraySerializerClass;
}
var CharArraySerializer_instance;
function CharArraySerializer_getInstance() {
  if (CharArraySerializer_instance === VOID)
    new (CharArraySerializer())();
  return CharArraySerializer_instance;
}
var DoubleArraySerializerClass;
function DoubleArraySerializer() {
  if (DoubleArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        DoubleArraySerializer_instance = null;
        super(serializer_0(DoubleCompanionObject_instance));
        DoubleArraySerializer_instance = this;
      }
      w20(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.w20((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      x20(_this__u8e3s4) {
        return new (DoubleArrayBuilder())(_this__u8e3s4);
      }
      x1u(_this__u8e3s4) {
        return this.x20((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n1x() {
        return new Float64Array(0);
      }
      y20(decoder, index, builder, checkIndex) {
        builder.b21(decoder.w1r(this.e1x_1, index));
      }
      i1v(decoder, index, builder, checkIndex) {
        return this.y20(decoder, index, builder instanceof DoubleArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o1x(decoder, index, builder, checkIndex) {
        return this.y20(decoder, index, builder instanceof DoubleArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      c21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.c1t(this.e1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      p1x(encoder, content, size) {
        return this.c21(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'DoubleArraySerializer', VOID, VOID, [KSerializer(), PrimitiveArraySerializer()]);
    DoubleArraySerializerClass = $;
  }
  return DoubleArraySerializerClass;
}
var DoubleArraySerializer_instance;
function DoubleArraySerializer_getInstance() {
  if (DoubleArraySerializer_instance === VOID)
    new (DoubleArraySerializer())();
  return DoubleArraySerializer_instance;
}
var FloatArraySerializerClass;
function FloatArraySerializer() {
  if (FloatArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        FloatArraySerializer_instance = null;
        super(serializer_1(FloatCompanionObject_instance));
        FloatArraySerializer_instance = this;
      }
      f21(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.f21((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      g21(_this__u8e3s4) {
        return new (FloatArrayBuilder())(_this__u8e3s4);
      }
      x1u(_this__u8e3s4) {
        return this.g21((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n1x() {
        return new Float32Array(0);
      }
      h21(decoder, index, builder, checkIndex) {
        builder.k21(decoder.v1r(this.e1x_1, index));
      }
      i1v(decoder, index, builder, checkIndex) {
        return this.h21(decoder, index, builder instanceof FloatArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o1x(decoder, index, builder, checkIndex) {
        return this.h21(decoder, index, builder instanceof FloatArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      l21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.b1t(this.e1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      p1x(encoder, content, size) {
        return this.l21(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'FloatArraySerializer', VOID, VOID, [KSerializer(), PrimitiveArraySerializer()]);
    FloatArraySerializerClass = $;
  }
  return FloatArraySerializerClass;
}
var FloatArraySerializer_instance;
function FloatArraySerializer_getInstance() {
  if (FloatArraySerializer_instance === VOID)
    new (FloatArraySerializer())();
  return FloatArraySerializer_instance;
}
var LongArraySerializerClass;
function LongArraySerializer() {
  if (LongArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        LongArraySerializer_instance = null;
        super(serializer_2(Companion_instance));
        LongArraySerializer_instance = this;
      }
      o21(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.o21((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      p21(_this__u8e3s4) {
        return new (LongArrayBuilder())(_this__u8e3s4);
      }
      x1u(_this__u8e3s4) {
        return this.p21((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n1x() {
        return new BigInt64Array(0);
      }
      q21(decoder, index, builder, checkIndex) {
        builder.t21(decoder.u1r(this.e1x_1, index));
      }
      i1v(decoder, index, builder, checkIndex) {
        return this.q21(decoder, index, builder instanceof LongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o1x(decoder, index, builder, checkIndex) {
        return this.q21(decoder, index, builder instanceof LongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      u21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.a1t(this.e1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      p1x(encoder, content, size) {
        return this.u21(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'LongArraySerializer', VOID, VOID, [KSerializer(), PrimitiveArraySerializer()]);
    LongArraySerializerClass = $;
  }
  return LongArraySerializerClass;
}
var LongArraySerializer_instance;
function LongArraySerializer_getInstance() {
  if (LongArraySerializer_instance === VOID)
    new (LongArraySerializer())();
  return LongArraySerializer_instance;
}
var ULongArraySerializerClass;
function ULongArraySerializer() {
  if (ULongArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ULongArraySerializer_instance = null;
        super(serializer_3(Companion_getInstance_0()));
        ULongArraySerializer_instance = this;
      }
      x21(_this__u8e3s4) {
        return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
      }
      c1w(_this__u8e3s4) {
        return this.x21(_this__u8e3s4 instanceof ULongArray() ? _this__u8e3s4.cv_1 : THROW_CCE());
      }
      y21(_this__u8e3s4) {
        return new (ULongArrayBuilder())(_this__u8e3s4);
      }
      x1u(_this__u8e3s4) {
        return this.y21(_this__u8e3s4 instanceof ULongArray() ? _this__u8e3s4.cv_1 : THROW_CCE());
      }
      z21() {
        return _ULongArray___init__impl__twm1l3(0);
      }
      n1x() {
        return new (ULongArray())(this.z21());
      }
      a22(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toULong' call
        var this_0 = decoder.z1r(this.e1x_1, index).f1r();
        var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
        builder.d22(tmp$ret$0);
      }
      i1v(decoder, index, builder, checkIndex) {
        return this.a22(decoder, index, builder instanceof ULongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o1x(decoder, index, builder, checkIndex) {
        return this.a22(decoder, index, builder instanceof ULongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      e22(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.f1t(this.e1x_1, i);
            // Inline function 'kotlin.ULong.toLong' call
            var this_0 = ULongArray__get_impl_pr71q9(content, i);
            var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
            tmp.p1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      p1x(encoder, content, size) {
        return this.e22(encoder, content instanceof ULongArray() ? content.cv_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ULongArraySerializer', VOID, VOID, [KSerializer(), PrimitiveArraySerializer()]);
    ULongArraySerializerClass = $;
  }
  return ULongArraySerializerClass;
}
var ULongArraySerializer_instance;
function ULongArraySerializer_getInstance() {
  if (ULongArraySerializer_instance === VOID)
    new (ULongArraySerializer())();
  return ULongArraySerializer_instance;
}
var IntArraySerializerClass;
function IntArraySerializer() {
  if (IntArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        IntArraySerializer_instance = null;
        super(serializer_4(IntCompanionObject_instance));
        IntArraySerializer_instance = this;
      }
      h22(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.h22((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      i22(_this__u8e3s4) {
        return new (IntArrayBuilder())(_this__u8e3s4);
      }
      x1u(_this__u8e3s4) {
        return this.i22((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n1x() {
        return new Int32Array(0);
      }
      j22(decoder, index, builder, checkIndex) {
        builder.m22(decoder.t1r(this.e1x_1, index));
      }
      i1v(decoder, index, builder, checkIndex) {
        return this.j22(decoder, index, builder instanceof IntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o1x(decoder, index, builder, checkIndex) {
        return this.j22(decoder, index, builder instanceof IntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      n22(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.z1s(this.e1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      p1x(encoder, content, size) {
        return this.n22(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'IntArraySerializer', VOID, VOID, [KSerializer(), PrimitiveArraySerializer()]);
    IntArraySerializerClass = $;
  }
  return IntArraySerializerClass;
}
var IntArraySerializer_instance;
function IntArraySerializer_getInstance() {
  if (IntArraySerializer_instance === VOID)
    new (IntArraySerializer())();
  return IntArraySerializer_instance;
}
var UIntArraySerializerClass;
function UIntArraySerializer() {
  if (UIntArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UIntArraySerializer_instance = null;
        super(serializer_5(Companion_getInstance_1()));
        UIntArraySerializer_instance = this;
      }
      q22(_this__u8e3s4) {
        return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
      }
      c1w(_this__u8e3s4) {
        return this.q22(_this__u8e3s4 instanceof UIntArray() ? _this__u8e3s4.qu_1 : THROW_CCE());
      }
      r22(_this__u8e3s4) {
        return new (UIntArrayBuilder())(_this__u8e3s4);
      }
      x1u(_this__u8e3s4) {
        return this.r22(_this__u8e3s4 instanceof UIntArray() ? _this__u8e3s4.qu_1 : THROW_CCE());
      }
      s22() {
        return _UIntArray___init__impl__ghjpc6(0);
      }
      n1x() {
        return new (UIntArray())(this.s22());
      }
      t22(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = decoder.z1r(this.e1x_1, index).e1r();
        var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
        builder.w22(tmp$ret$0);
      }
      i1v(decoder, index, builder, checkIndex) {
        return this.t22(decoder, index, builder instanceof UIntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o1x(decoder, index, builder, checkIndex) {
        return this.t22(decoder, index, builder instanceof UIntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      x22(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.f1t(this.e1x_1, i);
            // Inline function 'kotlin.UInt.toInt' call
            var this_0 = UIntArray__get_impl_gp5kza(content, i);
            var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
            tmp.o1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      p1x(encoder, content, size) {
        return this.x22(encoder, content instanceof UIntArray() ? content.qu_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UIntArraySerializer', VOID, VOID, [KSerializer(), PrimitiveArraySerializer()]);
    UIntArraySerializerClass = $;
  }
  return UIntArraySerializerClass;
}
var UIntArraySerializer_instance;
function UIntArraySerializer_getInstance() {
  if (UIntArraySerializer_instance === VOID)
    new (UIntArraySerializer())();
  return UIntArraySerializer_instance;
}
var ShortArraySerializerClass;
function ShortArraySerializer() {
  if (ShortArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ShortArraySerializer_instance = null;
        super(serializer_6(ShortCompanionObject_instance));
        ShortArraySerializer_instance = this;
      }
      a23(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.a23((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      b23(_this__u8e3s4) {
        return new (ShortArrayBuilder())(_this__u8e3s4);
      }
      x1u(_this__u8e3s4) {
        return this.b23((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n1x() {
        return new Int16Array(0);
      }
      c23(decoder, index, builder, checkIndex) {
        builder.f23(decoder.s1r(this.e1x_1, index));
      }
      i1v(decoder, index, builder, checkIndex) {
        return this.c23(decoder, index, builder instanceof ShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o1x(decoder, index, builder, checkIndex) {
        return this.c23(decoder, index, builder instanceof ShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      g23(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.y1s(this.e1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      p1x(encoder, content, size) {
        return this.g23(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ShortArraySerializer', VOID, VOID, [KSerializer(), PrimitiveArraySerializer()]);
    ShortArraySerializerClass = $;
  }
  return ShortArraySerializerClass;
}
var ShortArraySerializer_instance;
function ShortArraySerializer_getInstance() {
  if (ShortArraySerializer_instance === VOID)
    new (ShortArraySerializer())();
  return ShortArraySerializer_instance;
}
var UShortArraySerializerClass;
function UShortArraySerializer() {
  if (UShortArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UShortArraySerializer_instance = null;
        super(serializer_7(Companion_getInstance_2()));
        UShortArraySerializer_instance = this;
      }
      j23(_this__u8e3s4) {
        return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
      }
      c1w(_this__u8e3s4) {
        return this.j23(_this__u8e3s4 instanceof UShortArray() ? _this__u8e3s4.ov_1 : THROW_CCE());
      }
      k23(_this__u8e3s4) {
        return new (UShortArrayBuilder())(_this__u8e3s4);
      }
      x1u(_this__u8e3s4) {
        return this.k23(_this__u8e3s4 instanceof UShortArray() ? _this__u8e3s4.ov_1 : THROW_CCE());
      }
      l23() {
        return _UShortArray___init__impl__9b26ef(0);
      }
      n1x() {
        return new (UShortArray())(this.l23());
      }
      m23(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = decoder.z1r(this.e1x_1, index).d1r();
        var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
        builder.p23(tmp$ret$0);
      }
      i1v(decoder, index, builder, checkIndex) {
        return this.m23(decoder, index, builder instanceof UShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o1x(decoder, index, builder, checkIndex) {
        return this.m23(decoder, index, builder instanceof UShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      q23(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.f1t(this.e1x_1, i);
            // Inline function 'kotlin.UShort.toShort' call
            var this_0 = UShortArray__get_impl_fnbhmx(content, i);
            var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
            tmp.n1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      p1x(encoder, content, size) {
        return this.q23(encoder, content instanceof UShortArray() ? content.ov_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UShortArraySerializer', VOID, VOID, [KSerializer(), PrimitiveArraySerializer()]);
    UShortArraySerializerClass = $;
  }
  return UShortArraySerializerClass;
}
var UShortArraySerializer_instance;
function UShortArraySerializer_getInstance() {
  if (UShortArraySerializer_instance === VOID)
    new (UShortArraySerializer())();
  return UShortArraySerializer_instance;
}
var ByteArraySerializerClass;
function ByteArraySerializer() {
  if (ByteArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ByteArraySerializer_instance = null;
        super(serializer_8(ByteCompanionObject_instance));
        ByteArraySerializer_instance = this;
      }
      t23(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.t23((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      u23(_this__u8e3s4) {
        return new (ByteArrayBuilder())(_this__u8e3s4);
      }
      x1u(_this__u8e3s4) {
        return this.u23((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n1x() {
        return new Int8Array(0);
      }
      v23(decoder, index, builder, checkIndex) {
        builder.y23(decoder.r1r(this.e1x_1, index));
      }
      i1v(decoder, index, builder, checkIndex) {
        return this.v23(decoder, index, builder instanceof ByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o1x(decoder, index, builder, checkIndex) {
        return this.v23(decoder, index, builder instanceof ByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      z23(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.x1s(this.e1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      p1x(encoder, content, size) {
        return this.z23(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ByteArraySerializer', VOID, VOID, [KSerializer(), PrimitiveArraySerializer()]);
    ByteArraySerializerClass = $;
  }
  return ByteArraySerializerClass;
}
var ByteArraySerializer_instance;
function ByteArraySerializer_getInstance() {
  if (ByteArraySerializer_instance === VOID)
    new (ByteArraySerializer())();
  return ByteArraySerializer_instance;
}
var UByteArraySerializerClass;
function UByteArraySerializer() {
  if (UByteArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UByteArraySerializer_instance = null;
        super(serializer_9(Companion_getInstance_3()));
        UByteArraySerializer_instance = this;
      }
      c24(_this__u8e3s4) {
        return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
      }
      c1w(_this__u8e3s4) {
        return this.c24(_this__u8e3s4 instanceof UByteArray() ? _this__u8e3s4.eu_1 : THROW_CCE());
      }
      d24(_this__u8e3s4) {
        return new (UByteArrayBuilder())(_this__u8e3s4);
      }
      x1u(_this__u8e3s4) {
        return this.d24(_this__u8e3s4 instanceof UByteArray() ? _this__u8e3s4.eu_1 : THROW_CCE());
      }
      e24() {
        return _UByteArray___init__impl__ip4y9n(0);
      }
      n1x() {
        return new (UByteArray())(this.e24());
      }
      f24(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = decoder.z1r(this.e1x_1, index).c1r();
        var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
        builder.i24(tmp$ret$0);
      }
      i1v(decoder, index, builder, checkIndex) {
        return this.f24(decoder, index, builder instanceof UByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o1x(decoder, index, builder, checkIndex) {
        return this.f24(decoder, index, builder instanceof UByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      j24(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.f1t(this.e1x_1, i);
            // Inline function 'kotlin.UByte.toByte' call
            var this_0 = UByteArray__get_impl_t5f3hv(content, i);
            var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
            tmp.m1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      p1x(encoder, content, size) {
        return this.j24(encoder, content instanceof UByteArray() ? content.eu_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UByteArraySerializer', VOID, VOID, [KSerializer(), PrimitiveArraySerializer()]);
    UByteArraySerializerClass = $;
  }
  return UByteArraySerializerClass;
}
var UByteArraySerializer_instance;
function UByteArraySerializer_getInstance() {
  if (UByteArraySerializer_instance === VOID)
    new (UByteArraySerializer())();
  return UByteArraySerializer_instance;
}
var BooleanArraySerializerClass;
function BooleanArraySerializer() {
  if (BooleanArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        BooleanArraySerializer_instance = null;
        super(serializer_10(BooleanCompanionObject_instance));
        BooleanArraySerializer_instance = this;
      }
      m24(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.m24((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n24(_this__u8e3s4) {
        return new (BooleanArrayBuilder())(_this__u8e3s4);
      }
      x1u(_this__u8e3s4) {
        return this.n24((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n1x() {
        return booleanArray(0);
      }
      o24(decoder, index, builder, checkIndex) {
        builder.r24(decoder.q1r(this.e1x_1, index));
      }
      i1v(decoder, index, builder, checkIndex) {
        return this.o24(decoder, index, builder instanceof BooleanArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o1x(decoder, index, builder, checkIndex) {
        return this.o24(decoder, index, builder instanceof BooleanArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      s24(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.w1s(this.e1x_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      p1x(encoder, content, size) {
        return this.s24(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'BooleanArraySerializer', VOID, VOID, [KSerializer(), PrimitiveArraySerializer()]);
    BooleanArraySerializerClass = $;
  }
  return BooleanArraySerializerClass;
}
var BooleanArraySerializer_instance;
function BooleanArraySerializer_getInstance() {
  if (BooleanArraySerializer_instance === VOID)
    new (BooleanArraySerializer())();
  return BooleanArraySerializer_instance;
}
var CharArrayBuilderClass;
function CharArrayBuilder() {
  if (CharArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.q20_1 = bufferWithData;
        this.r20_1 = bufferWithData.length;
        this.k1x(10);
      }
      g1x() {
        return this.r20_1;
      }
      k1x(requiredCapacity) {
        if (this.q20_1.length < requiredCapacity)
          this.q20_1 = copyOf(this.q20_1, coerceAtLeast(requiredCapacity, imul(this.q20_1.length, 2)));
      }
      s20(c) {
        this.r1x();
        var tmp = this.q20_1;
        var _unary__edvuaz = this.r20_1;
        this.r20_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      i1x() {
        return copyOf(this.q20_1, this.r20_1);
      }
    }
    initMetadataForClass($, 'CharArrayBuilder');
    CharArrayBuilderClass = $;
  }
  return CharArrayBuilderClass;
}
var DoubleArrayBuilderClass;
function DoubleArrayBuilder() {
  if (DoubleArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.z20_1 = bufferWithData;
        this.a21_1 = bufferWithData.length;
        this.k1x(10);
      }
      g1x() {
        return this.a21_1;
      }
      k1x(requiredCapacity) {
        if (this.z20_1.length < requiredCapacity)
          this.z20_1 = copyOf_0(this.z20_1, coerceAtLeast(requiredCapacity, imul(this.z20_1.length, 2)));
      }
      b21(c) {
        this.r1x();
        var tmp = this.z20_1;
        var _unary__edvuaz = this.a21_1;
        this.a21_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      i1x() {
        return copyOf_0(this.z20_1, this.a21_1);
      }
    }
    initMetadataForClass($, 'DoubleArrayBuilder');
    DoubleArrayBuilderClass = $;
  }
  return DoubleArrayBuilderClass;
}
var FloatArrayBuilderClass;
function FloatArrayBuilder() {
  if (FloatArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.i21_1 = bufferWithData;
        this.j21_1 = bufferWithData.length;
        this.k1x(10);
      }
      g1x() {
        return this.j21_1;
      }
      k1x(requiredCapacity) {
        if (this.i21_1.length < requiredCapacity)
          this.i21_1 = copyOf_1(this.i21_1, coerceAtLeast(requiredCapacity, imul(this.i21_1.length, 2)));
      }
      k21(c) {
        this.r1x();
        var tmp = this.i21_1;
        var _unary__edvuaz = this.j21_1;
        this.j21_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      i1x() {
        return copyOf_1(this.i21_1, this.j21_1);
      }
    }
    initMetadataForClass($, 'FloatArrayBuilder');
    FloatArrayBuilderClass = $;
  }
  return FloatArrayBuilderClass;
}
var LongArrayBuilderClass;
function LongArrayBuilder() {
  if (LongArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.r21_1 = bufferWithData;
        this.s21_1 = bufferWithData.length;
        this.k1x(10);
      }
      g1x() {
        return this.s21_1;
      }
      k1x(requiredCapacity) {
        if (this.r21_1.length < requiredCapacity)
          this.r21_1 = copyOf_2(this.r21_1, coerceAtLeast(requiredCapacity, imul(this.r21_1.length, 2)));
      }
      t21(c) {
        this.r1x();
        var tmp = this.r21_1;
        var _unary__edvuaz = this.s21_1;
        this.s21_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      i1x() {
        return copyOf_2(this.r21_1, this.s21_1);
      }
    }
    initMetadataForClass($, 'LongArrayBuilder');
    LongArrayBuilderClass = $;
  }
  return LongArrayBuilderClass;
}
var ULongArrayBuilderClass;
function ULongArrayBuilder() {
  if (ULongArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.b22_1 = bufferWithData;
        this.c22_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
        this.k1x(10);
      }
      g1x() {
        return this.c22_1;
      }
      k1x(requiredCapacity) {
        if (_ULongArray___get_size__impl__ju6dtr(this.b22_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.b22_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.b22_1), 2));
          tmp.b22_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
        }
      }
      d22(c) {
        this.r1x();
        var tmp = this.b22_1;
        var _unary__edvuaz = this.c22_1;
        this.c22_1 = _unary__edvuaz + 1 | 0;
        ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
      }
      t24() {
        var tmp0 = this.b22_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.c22_1;
        return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
      }
      i1x() {
        return new (ULongArray())(this.t24());
      }
    }
    initMetadataForClass($, 'ULongArrayBuilder');
    ULongArrayBuilderClass = $;
  }
  return ULongArrayBuilderClass;
}
var IntArrayBuilderClass;
function IntArrayBuilder() {
  if (IntArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.k22_1 = bufferWithData;
        this.l22_1 = bufferWithData.length;
        this.k1x(10);
      }
      g1x() {
        return this.l22_1;
      }
      k1x(requiredCapacity) {
        if (this.k22_1.length < requiredCapacity)
          this.k22_1 = copyOf_3(this.k22_1, coerceAtLeast(requiredCapacity, imul(this.k22_1.length, 2)));
      }
      m22(c) {
        this.r1x();
        var tmp = this.k22_1;
        var _unary__edvuaz = this.l22_1;
        this.l22_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      i1x() {
        return copyOf_3(this.k22_1, this.l22_1);
      }
    }
    initMetadataForClass($, 'IntArrayBuilder');
    IntArrayBuilderClass = $;
  }
  return IntArrayBuilderClass;
}
var UIntArrayBuilderClass;
function UIntArrayBuilder() {
  if (UIntArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.u22_1 = bufferWithData;
        this.v22_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
        this.k1x(10);
      }
      g1x() {
        return this.v22_1;
      }
      k1x(requiredCapacity) {
        if (_UIntArray___get_size__impl__r6l8ci(this.u22_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.u22_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.u22_1), 2));
          tmp.u22_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
        }
      }
      w22(c) {
        this.r1x();
        var tmp = this.u22_1;
        var _unary__edvuaz = this.v22_1;
        this.v22_1 = _unary__edvuaz + 1 | 0;
        UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
      }
      u24() {
        var tmp0 = this.u22_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.v22_1;
        return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
      }
      i1x() {
        return new (UIntArray())(this.u24());
      }
    }
    initMetadataForClass($, 'UIntArrayBuilder');
    UIntArrayBuilderClass = $;
  }
  return UIntArrayBuilderClass;
}
var ShortArrayBuilderClass;
function ShortArrayBuilder() {
  if (ShortArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.d23_1 = bufferWithData;
        this.e23_1 = bufferWithData.length;
        this.k1x(10);
      }
      g1x() {
        return this.e23_1;
      }
      k1x(requiredCapacity) {
        if (this.d23_1.length < requiredCapacity)
          this.d23_1 = copyOf_4(this.d23_1, coerceAtLeast(requiredCapacity, imul(this.d23_1.length, 2)));
      }
      f23(c) {
        this.r1x();
        var tmp = this.d23_1;
        var _unary__edvuaz = this.e23_1;
        this.e23_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      i1x() {
        return copyOf_4(this.d23_1, this.e23_1);
      }
    }
    initMetadataForClass($, 'ShortArrayBuilder');
    ShortArrayBuilderClass = $;
  }
  return ShortArrayBuilderClass;
}
var UShortArrayBuilderClass;
function UShortArrayBuilder() {
  if (UShortArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.n23_1 = bufferWithData;
        this.o23_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
        this.k1x(10);
      }
      g1x() {
        return this.o23_1;
      }
      k1x(requiredCapacity) {
        if (_UShortArray___get_size__impl__jqto1b(this.n23_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.n23_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.n23_1), 2));
          tmp.n23_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
        }
      }
      p23(c) {
        this.r1x();
        var tmp = this.n23_1;
        var _unary__edvuaz = this.o23_1;
        this.o23_1 = _unary__edvuaz + 1 | 0;
        UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
      }
      v24() {
        var tmp0 = this.n23_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.o23_1;
        return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
      }
      i1x() {
        return new (UShortArray())(this.v24());
      }
    }
    initMetadataForClass($, 'UShortArrayBuilder');
    UShortArrayBuilderClass = $;
  }
  return UShortArrayBuilderClass;
}
var ByteArrayBuilderClass;
function ByteArrayBuilder() {
  if (ByteArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.w23_1 = bufferWithData;
        this.x23_1 = bufferWithData.length;
        this.k1x(10);
      }
      g1x() {
        return this.x23_1;
      }
      k1x(requiredCapacity) {
        if (this.w23_1.length < requiredCapacity)
          this.w23_1 = copyOf_5(this.w23_1, coerceAtLeast(requiredCapacity, imul(this.w23_1.length, 2)));
      }
      y23(c) {
        this.r1x();
        var tmp = this.w23_1;
        var _unary__edvuaz = this.x23_1;
        this.x23_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      i1x() {
        return copyOf_5(this.w23_1, this.x23_1);
      }
    }
    initMetadataForClass($, 'ByteArrayBuilder');
    ByteArrayBuilderClass = $;
  }
  return ByteArrayBuilderClass;
}
var UByteArrayBuilderClass;
function UByteArrayBuilder() {
  if (UByteArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.g24_1 = bufferWithData;
        this.h24_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
        this.k1x(10);
      }
      g1x() {
        return this.h24_1;
      }
      k1x(requiredCapacity) {
        if (_UByteArray___get_size__impl__h6pkdv(this.g24_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.g24_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.g24_1), 2));
          tmp.g24_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
        }
      }
      i24(c) {
        this.r1x();
        var tmp = this.g24_1;
        var _unary__edvuaz = this.h24_1;
        this.h24_1 = _unary__edvuaz + 1 | 0;
        UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
      }
      w24() {
        var tmp0 = this.g24_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.h24_1;
        return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
      }
      i1x() {
        return new (UByteArray())(this.w24());
      }
    }
    initMetadataForClass($, 'UByteArrayBuilder');
    UByteArrayBuilderClass = $;
  }
  return UByteArrayBuilderClass;
}
var BooleanArrayBuilderClass;
function BooleanArrayBuilder() {
  if (BooleanArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.p24_1 = bufferWithData;
        this.q24_1 = bufferWithData.length;
        this.k1x(10);
      }
      g1x() {
        return this.q24_1;
      }
      k1x(requiredCapacity) {
        if (this.p24_1.length < requiredCapacity)
          this.p24_1 = copyOf_6(this.p24_1, coerceAtLeast(requiredCapacity, imul(this.p24_1.length, 2)));
      }
      r24(c) {
        this.r1x();
        var tmp = this.p24_1;
        var _unary__edvuaz = this.q24_1;
        this.q24_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      i1x() {
        return copyOf_6(this.p24_1, this.q24_1);
      }
    }
    initMetadataForClass($, 'BooleanArrayBuilder');
    BooleanArrayBuilderClass = $;
  }
  return BooleanArrayBuilderClass;
}
//region block: exports
export {
  BooleanArraySerializer_getInstance as BooleanArraySerializer_getInstance11cyy1cd886m9,
  ByteArraySerializer_getInstance as ByteArraySerializer_getInstancebtnovhz524d2,
  CharArraySerializer_getInstance as CharArraySerializer_getInstance273qcmc7nv9pr,
  DoubleArraySerializer_getInstance as DoubleArraySerializer_getInstance3jua9b0m2td64,
  FloatArraySerializer_getInstance as FloatArraySerializer_getInstance3i9g5x4pxeneh,
  IntArraySerializer_getInstance as IntArraySerializer_getInstance2nukogiyp6mng,
  LongArraySerializer_getInstance as LongArraySerializer_getInstanceihd2vckfv0is,
  ShortArraySerializer_getInstance as ShortArraySerializer_getInstance3v0omj1cofwuf,
  UByteArraySerializer_getInstance as UByteArraySerializer_getInstanceswbahy14ath9,
  UIntArraySerializer_getInstance as UIntArraySerializer_getInstance3al4hez1t3o40,
  ULongArraySerializer_getInstance as ULongArraySerializer_getInstance3i2p1uc2e59s2,
  UShortArraySerializer_getInstance as UShortArraySerializer_getInstance47o7272nox02,
};
//endregion

//# sourceMappingURL=PrimitiveArraysSerializers.mjs.map
